$(document).ready(function ($) {
  $("#suggest_variant").on("click", function (e) {
    e.preventDefault();
    suggest_variant();
  });
  $("#input_hip, #input_waist").on("input", function (e) {
     $('#size_text').html("");
  });

  function hip_function(hip_size) {
    if (hip_size >= 0 && hip_size <= 40) {
      return "xs";
    } else if (hip_size > 40 && hip_size <= 42) {
      return "s";
    } else if (hip_size > 42 && hip_size <= 44) {
      return "m";
    } else if (hip_size > 44 && hip_size <= 46) {
      return "l";
    } else if (hip_size > 46 && hip_size <= 48) {
      return "xl";
    } else if (hip_size > 48 && hip_size <= 50) {
      return "2xl";
    } else if (hip_size > 50 && hip_size <= 54) {
      return "3xl";
    } else if (hip_size > 54 && hip_size <= 60) {
      return "4xl";
    } else {
      return "";
    }
  }

  function suggest_variant() {
    var waist_size = parseInt(document.querySelector("#input_waist").value);
    var hip_size = parseInt(document.querySelector("#input_hip").value);
    var size = "";
    var hwd = hip_size - waist_size;
    var msg = "";

    if (hwd <= 8) {
          var msg = `<p>Since BDY Stage 2 Fajas are designed in a extreme guitar shape, your BDY Faja will likely need alterations in the hips & thighs. <a href="https://thefajadoctor.com/pages/how-it-works" target="_blank">The Faja Doctor</a> offers 50% off your first alteration of your BDY Faja.</p>`;
      if (hip_size > 64) {
        console.log("No Size Match Available.");
      } else if (waist_size > 0 && waist_size < 25) {
        size = "xs";
      } else if (waist_size >= 25 && waist_size < 27) {
        size = "s";
      } else if (waist_size >= 27 && waist_size < 30) {
        size = "m";
      } else if (waist_size >= 30 && waist_size < 32) {
        size = "l";
      } else if (waist_size >= 32 && waist_size < 34) {
        size = "xl";
      } else if (waist_size >= 34 && waist_size < 36) {
        size = "2xl";
      } else if (waist_size >= 36 && waist_size < 38) {
        size = "3xl";
      } else if (waist_size >= 38 && waist_size <= 43) {
        size = "4xl";
      }
    } else if (hwd >= 9 && waist_size > 43) {
    } else if (hwd <= 9) {
      hip_size = hip_size + 5;
      size = hip_function(hip_size);
    } else if (hwd <= 10) {
      hip_size = hip_size + 4;
      size = hip_function(hip_size);
    } else if (hwd <= 11) {
      hip_size = hip_size + 3;
      size = hip_function(hip_size);
    } else if (hwd <= 12) {
      hip_size = hip_size + 2;
      size = hip_function(hip_size);
    } else if (hwd <= 13) {
      hip_size = hip_size + 1;
      size = hip_function(hip_size);
    } else if (hwd >= 14 && hwd <= 20) {
      size = hip_function(hip_size);
    } else if (hwd > 20) {
      size = hip_function(hip_size);
    } else {
      size = "";
    }
    
  if (size != "") {
       $(`.product__chip[data-option-value-dcase="${size}"]`).trigger('click');
       $('#size_text').html(`Your Size: ${size.toUpperCase()} ${msg}`);
    }else{
      $('#size_text').html("No size match available.");
      }
    $('#sp_notices_wrapper').html("");
  }
});
